import { Component, OnDestroy, OnInit, ViewEncapsulation, ElementRef } from "@angular/core";

import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { CoreConfigService } from "@core/services/config.service";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "vertical-layout",
  templateUrl: "./vertical-layout.component.html",
  styleUrls: ["./vertical-layout.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class VerticalLayoutComponent implements OnInit, OnDestroy {
  coreConfig: any;
  textDir: string = "ltr";
  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _elementRef: ElementRef,
    private TranslateModule: TranslateService
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
    switch (this.TranslateModule.currentLang) {
      case "fr":
        this.textDir = "ltr";
        break;
      case "en":
        this.textDir = "ltr";
        break;
      case "ar":
        this.textDir = "rtl";
        break;
      case "tn":
        this.textDir = "rtl";
        break;
    }
    this.TranslateModule.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang == "ar" || event.lang == "tn") {
        this.textDir = "rtl";
      } else {
        this.textDir = "ltr";
      }
    });
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      this.coreConfig = config;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
